import React from "react";
import { Text } from "@mantine/core";
import { DocumentService } from "../../Service/DocumentService";
import { FormatS } from "../../Service/FormatS";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";

const PositionGroupSum = ({
  isSummable,
  document,
  groupName,
  positions,
  values,
  columnStyles,
}) => {
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, document.language);

  if (!isSummable) {
    return null;
  }

  const pricedPositions = positions.filter(
    (position) => position.type !== "FREE_TEXT"
  );
  const summary = DocumentService.getDocumentSummary(
    document,
    pricedPositions,
    values
  );

  if (!summary) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        minHeight: 40,
        borderTop: "1px solid #dedede",
        paddingTop: 4,
        paddingBottom: 4,
        backgroundColor: "#f7f7f7",
        ...columnStyles.alignedContent,
      }}
    >
      <Text
        size="sm"
        color="dimmed"
        weight={600}
        style={{
          ...columnStyles.textColumn,
          paddingRight: 12,
          textAlign: "left",
          color: "#686868",
          fontSize: 13,
          lineHeight: 1.35,
        }}
      >
        {`${t("subtotal")} ${groupName}`}
      </Text>
      <Text
        size="sm"
        weight={700}
        style={{
          ...columnStyles.priceColumn,
          color: "#30343a",
          fontSize: 13,
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {FormatS.formatPriceWithCurrency(document.currency, summary.sum)}
      </Text>
    </div>
  );
};

export default PositionGroupSum;
